import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import useOnClickOutside from "use-onclickoutside";
import { withRouter } from "react-router-dom";

const Wrapper = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  right: ${(p) => p.right}px;
  padding: 5px 0;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 14px 25px rgba(0, 0, 0, 0.12);
  z-index: 1000;
`;

const Link = styled.div`
  padding: 5px 10px;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: rgb(244, 245, 247);
  }
`;

const Separator = styled.hr`
  margin: 5px 0;
  border: solid ${(p) => (p.color ? p.color : "#e8e8e8")};
  border-width: 1px 0 0;
`;

const Heading = styled.h3`
  margin-bottom: 0;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${(p) =>
    p.color
      ? p.color
      : p.theme.colors.secondary
      ? p.theme.colors.secondary
      : "#000"};
`;

const BtnDropDown = ({ open, setOpen, subItems, history }) => {
  const [right, setRight] = useState(0);

  const ref = useRef();

  useOnClickOutside(ref, () => setOpen(false));

  useEffect(() => {
    if (open) {
      const DOMRect = ref.current.getBoundingClientRect();

      if (DOMRect.left < 0) {
        setRight(DOMRect.left - 5);
      }
    }
  }, [open]);

  return (
    <React.Fragment>
      {open && (
        <Wrapper ref={ref} right={right}>
          {subItems.map((item, i) => {
            if (item.type === "link") {
              // Wrap this with Link
              return (
                <Link onClick={() => history.push("/" + item.url)}>
                  {item.heading}
                </Link>
              );
            }

            if (item.type === "heading") {
              return <Heading>{item.heading}</Heading>;
            }

            return <Separator />;
          })}
        </Wrapper>
      )}
    </React.Fragment>
  );
};

export default withRouter(BtnDropDown);
